import translationsEN from "./en/en.json";
import translationsFR from "./fr/fr.json";

export const supportedLngs: { [lang in SupportedLngsType]: string } = {
  en: "English",
  fr: "French",
};

export enum SupportedLngsType {
  EN = "en",
  FR = "fr",
}

export const defaultNS = "translation";

export const localeResources = {
  en: {
    translation: translationsEN,
  },
  fr: {
    translation: translationsFR,
  },
};
